import { useTranslation } from 'react-i18next';
import logo1 from './testimonials-logos/remax-logo.png';
import logo2 from './testimonials-logos/quaidao-logo.png';
import logo3 from './testimonials-logos/marrisson-logo.png';
import logo4 from './testimonials-logos/apollorion-global-logo.png';
import logo5 from './testimonials-logos/oneplan-logo.png';
import logo6 from './testimonials-logos/nebulai-logo.png';

const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-24 pb-12 sm:pb-48 w-full mx-auto max-w-screen-xl">
      {/* Full-width heading, centered on its own */}
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12">
        Testimonials
      </h2>

      {/* Logo container: width-limited */}
      <section className="w-[75%] mx-auto text-center">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-6 md:gap-8">
          {[logo1, logo2, logo3, logo4, logo5, logo6].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Logo ${index + 1}`}
              className="w-full h-auto transform transition-all duration-300 ease-in-out hover:scale-110"
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
